import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class ModerationFlows extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        return `/ticket/organizations/${organizationId}/moderation_flows`;
    }

    toOptions() {
        return {
            key: this.name,
            text: this.name,
            name: String(this.id),
            value: String(this.id)
        };
    }
}
